import '@sass/accordion.scss';
import CWAccordion from 'accordion.hs';

const accordions = document.querySelectorAll('.cw-accordion');
if (accordions.length) {
	new CWAccordion(accordions, {
		itemActiveClassName: 'cw-accordion__item--open',
		itemClassName: 'cw-accordion__item',
		itemTitleClassName: 'cw-accordion__item-title',
	});
}
